import { GiftCard } from '../slices/cart/types'

export const calculateTotalGiftCards = ({ giftCards = [] as GiftCard[] }): number =>
  giftCards.reduce((acc, giftCard) => acc + giftCard.amount.centAmount, 0);


export const getLastURIComponent = (): string => {
  const components = window.location.href.split('/');
  let lastURIComponent =
    components[components.length - 1] === ''
      ? components[components.length - 2]
      : components[components.length - 1];
  [lastURIComponent] = lastURIComponent.split('?');
  return lastURIComponent || ''; 
};




